<template>
    <div id="start-now">
        <section id="start-now-section">
            <div class="container">
                <div class="row justify-content-center text-center">
                    <div class="col-12">
                        <div class="intro-message">
                            <h2 class="section-title mb-5">Start Your Start-Up</h2>
                            <p class="section-subtitle text-left my-5">Which Industry Are You Going to Change First?</p>
                            <div class="row">
                                <div class="col-12">
                                    <div class="text-left py5">
                                        <router-link
                                                class="btn label-btn"
                                                v-for="(label, i) in labels"
                                                :key="i"
                                                :to="{name: 'quiz', params: {url: label === 'Other' ? 'P4Oy3x' : `BFkzsU`}, query: {industry: label === 'Other' ? null : label}}"
                                        >
                                            {{label}}
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <ul class="mt-5 d-flex p-0 list-unstyled justify-content-center">
                                <li>
                                    <router-link :to="{name: 'quiz', params: {url: 'P4Oy3x'}}" class="btn btn-hero btn-hero-primary mr-3">Start for Free</router-link>
                                </li>
                                <li>
                                    <button v-scroll-to="'#contact'" class="btn btn-hero btn-hero-secondary d-none d-lg-block">Contact sales</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

  export default {
    name: 'start-now',
    data () {
      return {
        labels: [
          'Sport',
          'Marketing',
          'Media',
          'Trips & Vacations',
          'Food',
          'Beauty',
          'Fashion',
          'Health',
          'Music',
          'Education',
          'Finance',
          'Shopping',
          'AdTech',
          'Data Management',
          'Dating',
          'Entertainment',
          'Other',
        ],
      }
    },
    methods: {
      onLabelSelect(label) {
        return label;
      },
    }
  }
</script>

<style lang="css" scoped>
    #start-now {
        min-height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        overflow: hidden;
        color: #fff;
        content: "";
        -webkit-box-align: center;
        -ms-flex-align: center;
        position: relative;
        background-image: linear-gradient(60deg, rgba(91, 155, 251, 0.95) 1%, rgba(0, 192, 146, 0.95) 75%);
        background-attachment: fixed;
        background-size: cover;
        padding-top: 150px;
        padding-bottom: 300px;
        margin-bottom: -300px;
    }
    #start-now:before {
        content: "";
        position: absolute;
        top: -100px;
        right: -50px;
        height: 200px;
        width: 130%;
        -webkit-transform: rotate(-4deg);
        -ms-transform: rotate(-4deg);
        transform: rotate(-4deg);
        z-index: 10;
        background: #fff;
    }
    .section-title {
        font-size: 36px;
        font-weight: 300;
        line-height: 1;
    }
    .section-subtitle {
        font-size: 25px;
    }
    .intro-message {
        padding-top: 50px;
        padding-bottom: 120px;
    }
    .btn-hero {
        height: 48px;
        min-width: 240px;
        font-weight: bold;
        border-radius: 21px;
        cursor: pointer;
        font-size: 20px;
        border: none;
    }
    .btn-hero-primary, .btn-hero-primary:hover, .btn-hero-primary:focus, .btn-hero-primary:active {
        color: #ffffff;
        background-image: linear-gradient(101deg, #3a71bb 2%, #9232bf 56%, #771bae 96%);
        padding-top: 10px;
        outline: none;
        border: none;
    }
    .btn-hero-primary:hover {
        color: #14D1BD;
    }
    .btn-hero-secondary {
        color: #14d1bd;
        background: #fff;
    }
    .btn-hero-secondary:hover {
        background: #e0e0e0;
    }
    .label-btn {
        display: inline-flex;
        border-radius: 25px;
        margin: 5px;
        padding-top: 4px;
        padding-bottom: 2px;
        border: solid 1px #fff;
        background: transparent;
        color: #fff;
        font-weight: 300;
        cursor: pointer;
        font-size: 18px;
    }
    .label-btn:hover{
        background: #fff;
        color: #00c092;
    }
</style>
